import _ from 'lodash'
import DateMultiSelector from 'scoreboard/components/date-multi-selector'
import momentHelper from 'scoreboard/components/moment-helper'
import * as d3 from 'd3-selection'
import DataType from 'scoreboard/datasets/model/data-type'
const { DATE } = DataType

var EquationAndDateMultiSelector = DateMultiSelector.extend({

	/**
	 * A UI control for specifying multiple dates and equations
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Array} options.dates date values that can be understood by moment.js
	 *
	 * @param {Array} options.equations equations
	 */
	initialize(options = {}) {
		DateMultiSelector.prototype.initialize.apply(this, arguments)

		let equationOptions = EquationAndDateMultiSelector.equationsToSelectOptions(options.equations)
		this.selectOptions = this.selectOptions.concat(equationOptions)
	},

	/*
	 * Override the DateMultiSelector _resultset method so we can open a dialog
	 * if they click on an equation rather than show the dropdown w/ a calendar
	 */
	_resultset: function (selection) {
		let activeTag = this.activeTag()

		if (activeTag && activeTag.dataset.type === 'equation') {
			// If they clicked an active item and it's not a date
			// Modify the data bound to the select so we can change its state to closed
			let selectData = d3.select(this.el.nextSibling).datum()
			selectData.open = false
			this.renderSelect(false)

			// launch the equation dialog
			this.trigger('edit-equation', activeTag.value)

			return
		}

		return DateMultiSelector.prototype._resultset.apply(this, arguments)
	},

	val(dates) {
		if (_.isUndefined(dates)) {
			return _.map(this.$(':selected'), option => {
				if (option.dataset.type === DATE) {
					return momentHelper.isoDate(option.value)
				} else {
					return option.value
				}
			})
		} else {
			DateMultiSelector.prototype.val.apply(this, arguments)
		}
	},

	cleanup: function () {
		_.invoke(this.markedField, 'clearError')
	}

}, {

	equationsToSelectOptions(equations) {
		return _.map(equations || [], equation => {
			return {
				label: _.escape(equation),
				value: equation,
				dataset: {
					type: 'equation'
				},
				selected: true
			}
		})
	}

})

export default EquationAndDateMultiSelector

EquationAndDateMultiSelector.__filename__ = 'datasets/filters/equation-and-date-multi-selector.js'
